
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import { NOKODIA_COLORS } from '@/utils/assessmentUtils';
import { sanitizeHTML } from '@/utils/sanitizeUtils';

interface AssessmentInterpretationProps {
  advice: string;
  isLoading: boolean;
  error: string | null;
}

export const AssessmentInterpretation: React.FC<AssessmentInterpretationProps> = ({
  advice,
  isLoading,
  error
}) => {
  // Sanitiser le contenu HTML avant l'affichage pour éviter les attaques XSS
  const sanitizedAdvice = React.useMemo(() => {
    return sanitizeHTML(advice);
  }, [advice]);

  return (
    <Card className="border-2 border-gray-100">
      <CardContent className="p-6">
        <h3 className="text-2xl font-bold mb-4 text-center" style={{ color: NOKODIA_COLORS.primary }}>
          Interprétation personnalisée des résultats
        </h3>
        
        {isLoading ? (
          <div className="flex items-center justify-center py-4">
            <Loader2 className="h-5 w-5 animate-spin mr-2" />
            <span className="text-gray-600">Génération de votre analyse personnalisée...</span>
          </div>
        ) : error ? (
          <div className="text-gray-600">
            <p className="text-base text-red-600 mb-2 text-center">Erreur lors de la génération de l'analyse</p>
            <div dangerouslySetInnerHTML={{ __html: sanitizedAdvice }} className="text-left" />
          </div>
        ) : (
          <div 
            className="text-gray-700 leading-relaxed text-left max-w-4xl mx-auto"
            dangerouslySetInnerHTML={{ __html: sanitizedAdvice }}
          />
        )}
        <p className="text-xs text-gray-400 italic text-right mt-4">
          Analyse générée par l'IA personnalisée d'après vos réponses à l'audit flash, le {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}.
        </p>
      </CardContent>
    </Card>
  );
};
